import type {
  GenerateViewDescriptionClickedEvent,
  PublishDialogOpenedEvent,
  PublishPayloadPrepSuccessEvent,
  PublishReviewNavigationEvent,
  PublishSubmitEvent,
  PublishViewDataPreparedEvent,
  PublishViewFailureEvent,
  PublishViewSuccessEvent,
} from '@bizzdesign/modeler/models';
import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';

export const dialogPublishUiEvents = eventGroup({
  source: 'Dialog Publish UI',
  events: {
    dialogClosed: type<void>(),
    errorsReviewed: type<void>(),
    seeConflictsClicked: type<PublishReviewNavigationEvent>(),
    seeElementsClicked: type<PublishReviewNavigationEvent>(),
    submitted: type<PublishSubmitEvent>(),
    payloadPrepSuccess: type<PublishPayloadPrepSuccessEvent>(),
    payloadPrepFailure: type<void>(),
    dialogOpened: type<PublishDialogOpenedEvent>(),
    generateViewDescriptionClicked: type<GenerateViewDescriptionClickedEvent>(),
    viewDataPrepared: type<PublishViewDataPreparedEvent>(),
    updateExistingViewSelected: type<{ viewId: string }>(),
    publishNewViewClicked: type<void>(),
  },
});

export const dialogPublishApiEvents = eventGroup({
  source: 'Dialog Publish API',
  events: {
    publishSuccess: type<PublishViewSuccessEvent>(),
    publishFailure: type<PublishViewFailureEvent>(),
  },
});
